import { Button, Dropdown, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { rupiahFormat } from 'helpers/formatter'
import { IconCaretDown, IconMoreCircle } from 'components/icons'
import { OrdersListOperationResponseItem } from 'generated/api'
import { mapStatusOrder } from 'helpers/wording'

export interface PropsOrderCancelTable {
  data: OrdersListOperationResponseItem[]
  loading: boolean
  selectOrder: (order: OrdersListOperationResponseItem) => void
}

function OrderCancellationTable(props: PropsOrderCancelTable) {
  const columnsOrderCancel: ColumnsType<OrdersListOperationResponseItem> = [
    {
      title: (
        <div data-testid="col_no_title" className="flex">
          <Typography.Text className="font-semibold text-gray-800">No.</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: 'nomor',
      key: 'nomor',
      render: (_text, _row, index) => (
        <div data-testid="col_no_value" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{index + 1}.</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div data-testid="col_invoice_title" className="flex">
          <Typography.Text className="font-semibold">Invoice</Typography.Text>
        </div>
      ),
      width: '30%',
      dataIndex: 'invoiceNo',
      key: 'invoiceNo',
      render: text => (
        <div data-testid="col_invoice_value" className="flex flex-col">
          <Typography.Text> {text || '-'}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div data-testid="col_cancel_reason_title" className="flex">
          <Typography.Text className="font-semibold">Alasan Pembatalan</Typography.Text>
        </div>
      ),
      width: '30%',
      dataIndex: 'cancellationReason',
      key: 'cancellationReason',
      render: text => (
        <div data-testid="col_cancel_reason_value" className="flex flex-col">
          <Typography.Text> {text || '-'}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div data-testid="col_total_price_title" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Total Tagihan</Typography.Text>
        </div>
      ),
      width: '15%',
      dataIndex: 'totalItemPrice',
      key: 'total_price',
      render: text => (
        <Typography.Text data-testid="col_total_price_value" className="font-medium">
          {rupiahFormat(text)}
        </Typography.Text>
      ),
    },
    {
      title: (
        <div data-testid="col_status_title" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Status</Typography.Text>
        </div>
      ),
      dataIndex: 'status',
      width: '25%',
      key: 'status',
      render: text => {
        return (
          <Typography.Text data-testid="col_status_value" className="font-medium">
            {mapStatusOrder(text)}
          </Typography.Text>
        )
      },
    },
    {
      title: (
        <Typography.Text className="font-semibold text-gray-800">
          <IconMoreCircle />
        </Typography.Text>
      ),
      width: '5%',
      key: 'action',
      render: (_text, row, index) => (
        <Dropdown
          placement="bottomRight"
          trigger={['click']}
          dropdownRender={() => (
            <div className="flex flex-col gap-3 p-4 bg-white rounded-md shadow-xl">
              <span className="font-semibold pt-2 px-3">Aksi</span>
              <span
                data-testid="see_detail_order"
                onClick={() => props.selectOrder(row)}
                className="hover:bg-primary py-1 px-3 bg-white cursor-pointer hover:text-white rounded-lg"
              >
                Lihat Detail
              </span>
            </div>
          )}
          arrow
        >
          <Button
            data-testid={`select_table_member_dropdown_${index}`}
            block
            className="bg-transparent"
          >
            <Typography.Text className="font-medium cursor-pointer">
              <IconCaretDown />
            </Typography.Text>
          </Button>
        </Dropdown>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      loading={props.loading}
      data-testid="tbl_member"
      className="table-primary table-primary--admin sticky-table-header"
      columns={columnsOrderCancel}
      dataSource={props.data}
      pagination={false}
    />
  )
}

export default OrderCancellationTable
